module.exports = __webpack_public_path__ + "img/skills.26ebd1cf.svg";